import React from 'react';
import {useCart} from '../../../context/CartContext';
import Swal from 'sweetalert2';
import './EntrepriseCart.css';

const EntrepriseCart = () => {
    const {
        cartItems,
        removeFromCart,
        updateQuantity,
        clearCart,
        cartTotal,
        tvaAmount,
        totalWithTva
    } = useCart();

    const handleCheckout = () => {
        if (cartItems.length === 0) return;

        Swal.fire({
            title: 'Confirmer la commande',
            html: `
        <div style="text-align: left;">
          <p>Total HT: ${cartTotal.toLocaleString()} DT</p>
          <p>TVA (19%): ${tvaAmount.toLocaleString()} DT</p>
          <hr>
          <p><strong>Total TTC: ${totalWithTva.toLocaleString()} DT</strong></p>
        </div>
      `,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Passer la commande',
            cancelButtonText: 'Annuler',
            confirmButtonColor: '#1e3a5f'
        }).then((result) => {
            if (result.isConfirmed) {
                // Logique de commande ici
                Swal.fire('Commande validée !', 'Votre commande a été transmise à notre équipe. Vous recevrez une facture par email.', 'success');
                clearCart();
            }
        });
    };

    return (
        <div className="entreprise-cart-container">
            <div className="ent-section-header">
                <h2>Mon Panier</h2>
                <p>Gérez vos achats et finalisez votre commande</p>
            </div>

            {cartItems.length === 0 ? (
                <div className="empty-cart">
                    <span>🛒</span>
                    <h3>Votre panier est vide</h3>
                    <p>Explorez notre catalogue pour ajouter des produits.</p>
                </div>
            ) : (
                <div className="cart-layout">
                    <div className="cart-items">
                        {cartItems.map((item) => (
                            <div key={item._id} className="cart-item">
                                <div className="item-image">
                                    <img src={item.image ? `${import.meta.env.VITE_API_URL.replace('/api', '')}${item.image}` : 'https://via.placeholder.com/100'} alt={item.nom} />
                                </div>
                                <div className="item-info">
                                    <h3>{item.nom}</h3>
                                    <p className="item-price">{item.prix?.toLocaleString()} DT HT</p>
                                </div>
                                <div className="item-quantity">
                                    <button onClick={() => updateQuantity(item._id, item.quantity - 1)}>-</button>
                                    <span>{item.quantity}</span>
                                    <button onClick={() => updateQuantity(item._id, item.quantity + 1)}>+</button>
                                </div>
                                <div className="item-total">
                                    {(item.prix * item.quantity).toLocaleString()} DT
                                </div>
                                <button className="remove-btn" onClick={() => removeFromCart(item._id)}>🗑️</button>
                            </div>
                        ))}
                    </div>

                    <div className="cart-summary">
                        <h3>Résumé de la commande</h3>
                        <div className="summary-row">
                            <span>Total HT</span>
                            <span>{cartTotal.toLocaleString()} DT</span>
                        </div>
                        <div className="summary-row">
                            <span>TVA (19%)</span>
                            <span>{tvaAmount.toLocaleString()} DT</span>
                        </div>
                        <div className="summary-row total">
                            <span>Total TTC</span>
                            <span>{totalWithTva.toLocaleString()} DT</span>
                        </div>
                        <button className="checkout-btn" onClick={handleCheckout}>
                            Finaliser la commande
                        </button>
                        <button className="clear-btn" onClick={clearCart}>
                            Vider le panier
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EntrepriseCart;
